export default {
      id: "credit-notes-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#credit-notes-usage",
      toString: function () {
        return this.url;
      }
    }